import { Directive } from '@angular/core';

@Directive({
  selector: '[jd-select-unselectable]',
  host    : {
    '[attr.unselectable]': '"unselectable"',
    '[style.user-select]': '"none"'
  }
})
export class JdSelectUnselectableDirective {

}
